'use strict';

/**
 *
 */
angular.
module('moebiusProadapt').
factory('mbsLookupService', ['$rootScope', function mbsLookupServiceFactory($rootScope) {



    var lookupData = {};

    function fnGetLookupListForEti(etiId) {
        return lookupData[etiId];
    }

    function fnGetLookupForEtiByIdentifer(etiId, lookupIdentifier) {
        // console.log( '# # # # Accessing getLookupForEtiByIdentifer # # # # ' + lookupIdentifier + ' -> order by ' );
        return lookupData[etiId][lookupIdentifier]
    }


    return {
        reset: function() {
            return lookupData = {};
        },
        hasBeenCalled: function() {
            return !_.isEmpty(lookupData);
        },
        isLoadedEti: function (etiId) {
            return ! angular.isUndefined(lookupData[etiId]);
        },

        getLookupListForEti: fnGetLookupListForEti,

        getLookupForEtiByIdentifer: fnGetLookupForEtiByIdentifer,

        getValueForIdxForLookupForEtiByIdentifer: function(etiId, lookupIdentifier) {
            throw  ' Not Yet implemented getValueForIdxForLookupForEtiByIdentifer ';
            // var y = _.find(lookupData[etiId][lookupIdentifier], function(obj){ return obj.id === idx; });
            console.log('* / * / ' + y);
            return y;
        },

        storeData: function(data) {
            angular.forEach(data, function(value, etiId) {
                lookupData[etiId] = value;
            }, this);
        }
    }





}]);




// WEBPACK FOOTER //
// ./resources/assets/js/services/mbs-lookup.js